define('prototypes/onQuotaExceededError',['LocalStorage'],function (LocalStorage) {
    return function(ObjectName){
        LocalStorage.removeAllItemsOfType(ObjectName);
    }
});
